import { WARRANTY_EXTENSION_VARIANT_ID } from '@/lib/const';
import { WarrantyStatus } from '@/lib/myWatches/types';
import type { Watch } from '@/lib/myWatches/types';
import type { WatchProductSummary } from '@/lib/service/ecs/contracts';

export interface WarrantyExtensionOffer {
  duration: string;
  price: {
    amount: number;
    currency: string;
  };
}

export interface RepairDetailsSidebarEligibilityInput {
  warrantyCode: number | null;
  warranty: Watch | null;
  productSummary: WatchProductSummary | null;
  warrantyExtensionOffer: WarrantyExtensionOffer | null;
  ecsAvailable: boolean;
}

export interface RepairDetailsSidebarEligibility {
  showExtendWarranty: boolean;
  showNeedService: boolean;
  showRegisterWatch: boolean;
}

export function getRepairDetailsSidebarEligibility(
  input: RepairDetailsSidebarEligibilityInput
): RepairDetailsSidebarEligibility {
  const { warrantyCode, warranty, productSummary, warrantyExtensionOffer, ecsAvailable } = input;

  const showExtendWarranty =
    Boolean(WARRANTY_EXTENSION_VARIANT_ID) &&
    warrantyCode === WarrantyStatus.RegisteredBySelf &&
    Boolean(warrantyExtensionOffer?.duration) &&
    Boolean(warrantyExtensionOffer?.price) &&
    Boolean(warranty?.is_extendable);

  const showNeedService = warrantyCode === WarrantyStatus.RegisteredBySelf && ecsAvailable;

  const showRegisterWatch =
    warrantyCode === WarrantyStatus.ActiveAndUnbound &&
    Boolean(productSummary) &&
    !warranty?.is_bind;

  return {
    showExtendWarranty,
    showNeedService,
    showRegisterWatch,
  };
}

export function canRegisterWatchFromSidebar(
  eligibility: Pick<RepairDetailsSidebarEligibility, 'showRegisterWatch'>
): boolean {
  return eligibility.showRegisterWatch;
}
